import { AuthContext } from '@repo-level/core-front';
import { ConfigContext } from 'contexts/config';
import type { IPageVisibilityField } from 'contexts/config/helpers';
import { groupsExclude, groupsInclude } from 'helpers/cms';
import { allPass } from 'ramda';
import { useContext } from 'react';

type VisibilityKey = keyof IPageVisibilityField;
type VisibilityResult<T> = T extends VisibilityKey[] ? boolean[] : boolean;

export const useCmsPageVisibility = <T extends VisibilityKey | VisibilityKey[]>(
  key: T
): VisibilityResult<T> => {
  const { pagesVisibility } = useContext(ConfigContext);
  const { user } = useContext(AuthContext);
  const check = allPass([groupsInclude(user), groupsExclude(user)]);

  const checkKey = (k: VisibilityKey) => {
    if (!pagesVisibility) return true;

    const visibility = pagesVisibility[k];
    if (!visibility?.enable) return true;
    return check(visibility);
  };

  return (
    Array.isArray(key) ? key.map(checkKey) : checkKey(key as VisibilityKey)
  ) as VisibilityResult<T>;
};
